import { Box } from '@newulife/common'

const Page = ({
  sx = {},
  ...props
}) =>
  <Box
    {...props}
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      width: '100%',
      height: 'auto',
      backgroundColor: '#ffffff',
      pb: {
        xs: 4,
        md: 2,
      },

      ...sx
    }}
  />

export default Page